import React from 'react';
import { Instagram } from 'lucide-react';
import GalleryImage from '../molecules/GalleryImage';
import { motion } from 'framer-motion';

const GallerySection = () => {
    return (
        <section id="gallery" className="py-24 bg-white">
            <div className="container mx-auto px-6">
                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="serif text-4xl text-center mb-16"
                >
                    The Lookbook
                </motion.h2>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                    variants={{
                        hidden: { opacity: 0 },
                        visible: {
                            opacity: 1,
                            transition: { staggerChildren: 0.1 }
                        }
                    }}
                    className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4"
                >
                    <motion.div className="col-span-2 md:col-span-2 md:row-span-2 relative group overflow-hidden rounded-2xl aspect-square md:aspect-auto" variants={{ hidden: { opacity: 0, scale: 0.95 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } } }}>
                        <GalleryImage
                            src="https://images.unsplash.com/photo-1632345031435-8727f6897d53?auto=format&fit=crop&q=80&w=800"
                            alt="Featured"
                            featured={true}
                        />
                    </motion.div>
                    <motion.div className="relative group overflow-hidden rounded-2xl aspect-square" variants={{ hidden: { opacity: 0, scale: 0.95 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } } }}>
                        <GalleryImage src="https://images.unsplash.com/photo-1519014816548-bf5fe059798b?auto=format&fit=crop&q=80&w=600" alt="Gallery" />
                    </motion.div>
                    <motion.div className="relative group overflow-hidden rounded-2xl aspect-square" variants={{ hidden: { opacity: 0, scale: 0.95 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } } }}>
                        <GalleryImage src="https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&q=80&w=600" alt="Gallery" />
                    </motion.div>
                    <motion.div className="relative group overflow-hidden rounded-2xl aspect-square" variants={{ hidden: { opacity: 0, scale: 0.95 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } } }}>
                        <GalleryImage src="https://images.unsplash.com/photo-1632345031435-8727f6897d53?auto=format&fit=crop&q=80&w=600" alt="Gallery" />
                    </motion.div>
                    <motion.div className="relative group overflow-hidden rounded-2xl aspect-square" variants={{ hidden: { opacity: 0, scale: 0.95 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } } }}>
                        <GalleryImage src="https://images.unsplash.com/photo-1519014816548-bf5fe059798b?auto=format&fit=crop&q=80&w=600" alt="Gallery" />
                    </motion.div>
                </motion.div>

                <div className="text-center mt-12">
                    <a href="https://www.instagram.com/rich.trannnnnails/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest border-b-2 border-black pb-1 hover:text-purple-700 hover:border-purple-700 transition-colors">
                        Follow @rich.trannnnnails <Instagram className="w-4 h-4" />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default GallerySection;
